import {PhaseResource} from "client/resources";
import {union} from "lodash";

const envCount = (phase: PhaseResource): number => {
    return union(phase.AutomaticDeploymentTargets, phase.OptionalDeploymentTargets).length;
};

export default envCount;